/** 教务中心 - 运营身份路由 **/

// 运营平台轮播图管理-列表
const CarouselIndex = () => import('@pv/eduCenter/operation/carousel/index');
// 运营平台轮播图管理-详情
const CarouselDetails = () => import('@pv/eduCenter/operation/carousel/details');

// 运营平台轮播图管理-详情
const MessageList = () => import('@pv/eduCenter/common/mesaage/List');
// 运营平台轮播图管理-详情
const MessagePending = () => import('@pv/eduCenter/common/mesaage/Pending');

// 评价管理
const EvaluationIndex = () => import('@pv/eduCenter/operation/evaluation/Index');

// 学生请假 列表
const AskLeaveForStudent = () => import('@pv/eduCenter/common/askLeave/Index');
// 学生请假 请假退款审批
const CheckRefund = () => import('@pv/eduCenter/common/askLeave/CheckRefund');

// 学生请假 详情
const AskLeaveDetailsForStudent = () =>
  import('@pv/eduCenter/common/askLeave/Details');

// 学生请假 导入
const AskLeaveLeadIn = () => import('@pv/eduCenter/common/askLeave/LeadIn');

// 学生考勤 列表
const StudentAttance = () =>
  import('@pv/eduCenter/common/studentAttendance/Index');

// 学生考勤 详情
const StudentAttanceDetails = () =>
  import('@pv/eduCenter/common/studentAttendance/Details');

// 学生考勤（行政班）
const StudentAttanceNormalClass = () =>
  import('@pv/eduCenter/common/studentAttendance/NormalClassIndex');

// 学生考勤（行政班）编辑
const StudentAttanceNormalClassEdit = () =>
  import('@pv/eduCenter/common/studentAttendance/NormalClassEdit');

// 通知公告
const NoticeList = () => import('@pv/eduCenter/operation/notice/Index');
// 通知公告详情
const NoticeDetail = () => import('@pv/eduCenter/operation/notice/Detail');
// 通知公告新增/修改
const AddNotice = () => import('@pv/eduCenter/operation/notice/AddNotice');

// 课堂反馈
const ClassFeedback = () => import('@pv/eduCenter/common/classFeedback/Index');

// 学生请假 列表
const AskLeaveForTeacher = () => import('@pv/eduCenter/common/askLeave/IndexForTeacher');

export default [
  // 轮播图管理
  {
    path: '/eduCenter/operationCarousel/index',
    name: 'eduCenter_operationCarousel_index',
    meta: {
      title: '平台轮播图',
      activePath: '/eduCenter/operationCarousel/index',
      breadcrumb: '教务中心-轮播图管理-平台轮播图'
    },
    component: CarouselIndex
  },
  {
    path: '/eduCenter/operationCarousel/school',
    name: 'eduCenter_operationCarousel_school',
    meta: {
      title: '学校轮播图',
      activePath: '/eduCenter/operationCarousel/school',
      breadcrumb: '教务中心-轮播图管理-学校轮播图',
      showChangeSchool: true
    },
    component: CarouselIndex
  },
  // 轮播图详情-编辑
  {
    path: '/eduCenter/operationCarousel/index/carouselDetails',
    name: 'eduCenter_operationCarousel_index_carouselDetails',
    meta: {
      title: '轮播图详情',
      activePath: '/eduCenter/operationCarousel/index',
      breadcrumb: '教务中心-轮播图管理-轮播图详情'
    },
    component: CarouselDetails
  },
  // 消息管理
  {
    path: '/eduCenter/message/list',
    name: 'eduCenter_message_list',
    meta: {
      title: '消息管理',
      activePath: '/eduCenter/message/list',
      breadcrumb: '教务中心-消息管理-消息管理'
    },
    component: MessageList
  },
  // 消息管理 - 待办审批
  {
    path: '/eduCenter/message/list/pending',
    name: 'eduCenter_message_list_pending',
    meta: {
      title: '待办审批',
      activePath: '/eduCenter/message/list',
      breadcrumb: '教务中心-消息管理-消息管理-待办审批'
    },
    component: MessagePending
  },
  // 评价管理
  {
    path: '/eduCenter/operationEvaluation/Index',
    name: 'eduCenter_operationEvaluation_Index',
    meta: {
      title: '评价管理',
      activePath: '/eduCenter/operationEvaluation/Index',
      breadcrumb: '教务中心-评价管理'
    },
    component: EvaluationIndex
  },
  // 学生请假
  {
    path: '/eduCenter/askLeave/Index',
    name: 'eduCenter_askLeave_Index',
    meta: {
      title: '学生请假',
      activePath: '/eduCenter/askLeave/Index',
      breadcrumb: '教务中心-学生请假-学生请假'
    },
    component: AskLeaveForStudent
  },
  // 学生请假 退款审批
  {
    path: '/eduCenter/askLeave/Index/checkRefund',
    name: 'eduCenter_askLeave_Index_checkRefund',
    meta: {
      title: '请假退款审批',
      activePath: '/eduCenter/askLeave/Index',
      breadcrumb: '教务中心-学生请假-学生请假-请假退款审批'
    },
    component: CheckRefund
  },
  // 学生请假详情
  {
    path: '/eduCenter/askLeave/Index/Details',
    name: 'eduCenter_askLeave_Index_Details',
    meta: {
      title: '请假明细',
      activePath: '/eduCenter/askLeave/Index',
      breadcrumb: '教务中心-学生请假-学生请假-请假明细'
    },
    component: AskLeaveDetailsForStudent
  },
  // 学生请假导入
  {
    path: '/eduCenter/askLeave/Index/LeadIn',
    name: 'eduCenter_askLeave_Index_LeadIn',
    meta: {
      title: '学生请假导入',
      activePath: '/eduCenter/askLeave/Index/LeadIn',
      breadcrumb: '教务中心-学生请假-学生请假导入'
    },
    component: AskLeaveLeadIn
  },
  // 学生考勤列表
  {
    path: '/eduCenter/studentAttance/Index',
    name: 'eduCenter_studentAttance_Index',
    meta: {
      title: '学生考勤',
      activePath: '/eduCenter/studentAttance/Index',
      breadcrumb: '教务中心-学生考勤-学生考勤'
    },
    component: StudentAttance
  },
  // 学生考勤详情
  {
    path: '/eduCenter/studentAttance/Index/Details',
    name: 'eduCenter_studentAttance_Index_Details',
    meta: {
      title: '明细',
      activePath: '/eduCenter/studentAttance/Index',
      breadcrumb: '教务中心-学生考勤-学生考勤-明细'
    },
    component: StudentAttanceDetails
  },
  // 通知公告
  {
    path: '/eduCenter/notice/Index',
    name: 'eduCenter_notice_index',
    meta: {
      title: '班级通知',
      activePath: '/eduCenter/notice/index',
      breadcrumb: '教务中心-通知公告-班级通知'
      // showChangeSchool: true
    },
    component: NoticeList
  },
  // 通知公告
  {
    path: '/eduCenter/notice/Index',
    name: 'eduCenter_notice_eduIndex',
    meta: {
      title: '通知公告',
      activePath: '/eduCenter/notice/index',
      breadcrumb: '教务中心-通知公告-通知公告',
      showChangeSchool: true
    },
    component: NoticeList
  },
  {
    path: '/eduCenter/notice/sys',
    name: 'eduCenter_notice_sys',
    meta: {
      title: '系统通知',
      activePath: '/eduCenter/notice/sys',
      breadcrumb: '教务中心-通知公告-系统通知'
    },
    component: NoticeList
  },
  // 通知公告详情
  {
    path: '/eduCenter/notice/Index/detail',
    name: 'eduCenter_notice_index_detail',
    meta: {
      title: '通知公告详情',
      activePath: '/eduCenter/notice/index',
      breadcrumb: '教务中心-通知公告-通知公告-通知公告详情'
    },
    component: NoticeDetail
  },
  // 通知公告新增/修改
  {
    path: '/eduCenter/notice/Index/addnotice',
    name: 'eduCenter_notice_index_addnotice',
    meta: {
      title: '发布通知公告',
      activePath: '/eduCenter/notice/index',
      breadcrumb: '教务中心-通知公告-通知公告-发布通知公告'
    },
    component: AddNotice
  },
  // 分班管理跳转通知发布公告
  {
    path: '/courseSchedulCenter/divideClassManage/list/addnotice',
    name: 'courseSchedulCenter_divideClassManage_list_addnotice',
    meta: {
      title: '考勤记录',
      activePath: '/courseSchedulCenter/divideClassManage/list',
      breadcrumb: '排课中心-分班管理-分班管理-发布通知公告'
    },
    component: AddNotice
  },
  // 学生考勤列表
  {
    path: '/eduCenter/studentAttance/NormalClassIndex',
    name: 'eduCenter_studentAttance_NormalClassIndex',
    meta: {
      title: '学生考勤(行政班)',
      activePath: '/eduCenter/studentAttance/NormalClassIndex',
      breadcrumb: '教务中心-学生考勤-学生考勤(行政班)',
      showChangeSchool: true
    },
    component: StudentAttanceNormalClass
  }, {
    path: '/eduCenter/studentAttance/NormalClassEdit',
    name: 'eduCenter_studentAttance_NormalClassEdit',
    meta: {
      title: '学生考勤(行政班)修改考勤',
      activePath: '/eduCenter/studentAttance/NormalClassEdit',
      breadcrumb: '教务中心-学生考勤-学生考勤(行政班)修改考勤',
      showChangeSchool: true,
      showSwitchBtn: false,
      showBreadcrumb: true
    },
    component: StudentAttanceNormalClassEdit
  },
  // 课堂反馈
  {
    path: '/eduCenter/classFeedback/Index',
    name: 'eduCenter_classFeedback_Index',
    meta: {
      title: '课堂反馈',
      activePath: '/eduCenter/classFeedback/Index',
      breadcrumb: '教务中心-课堂反馈-课堂反馈'
    },
    component: ClassFeedback
  },
  // 教师请假
  {
    path: '/eduCenter/askLeave/TeacherIndex',
    name: 'eduCenter_askLeave_TeacherIndex',
    meta: {
      title: '教师请假',
      activePath: '/eduCenter/askLeave/TeacherIndex',
      breadcrumb: '教务中心-教师请假-教师请假'
    },
    component: AskLeaveForTeacher
  }
];
